import services from 'services/module';
import {tapfiliateLib} from '../lazy_modules';
import {LocalStorageSvc} from './LocalStorageSvc';
import {HttpSvcFactory} from './HttpSvc';
import {Utils} from '../underscore-extensions';

export class AffiliateSvc {
    private tapId           = '4142-17375a';
    private storageName     = 'anm_referrral_program';
    private storageValue    = this.LocalStorageSvc.get(this.storageName);
    private referralRequest = this.HttpSvc(`referral/foruser?product=${Utils.getProduct()}`);

    constructor(private $location: ng.ILocationService,
                private $q: ng.IQService,
                private LocalStorageSvc: LocalStorageSvc,
                private HttpSvc: HttpSvcFactory) {
    }

    init() {
        const {tap_a} = this.$location.search() as anm.AffiliateParams;
        tap_a && this.detectTap();
    }

    getAffiliateInfo() {
        return this.loadLib()
            .then(() => this.referralRequest.secureGet())
            .then(r => r.data)
            .then((affiliateInfo: ApiError | anm.AffiliateInfo) => {
                return Utils.isApiError(affiliateInfo) ? this.updateReferralForUser() : affiliateInfo;
            });
    }

    private loadLib() {
        const deferred = this.$q.defer();
        loadScripts([tapfiliateLib], () => deferred.resolve());
        return deferred.promise;
    }

    private detectTap() {
        const programName = 'tap';
        this.loadLib().then(() => {
            window.tap.create(this.tapId);
            window.tap.detectClick();
            this.LocalStorageSvc.set(this.storageName, programName);
            this.storageValue = programName;
        });
    }

    private updateReferralForUser() {
        if (!this.storageValue) return this.$q.reject();

        return this.getPaymentInfo()
            .then((paymentInfo: {id: number}) => {
                const referralInfo = {
                    programId: this.storageValue,
                    paymentInfo: paymentInfo.id
                };
                return this.referralRequest.securePut(referralInfo);
            })
            .then(r => r.data)
            .then((res: ApiError | anm.AffiliateInfo) => {
                return Utils.isApiError(res) ? this.$q.reject() : res;
            });
    }

    private getPaymentInfo() {
        const deferred = this.$q.defer();

        window.tap && window.tap.conversion(
            `CUST_${options.user.userId}`,
            0, null, null,
            deferred.resolve.bind(deferred)
        );

        return deferred.promise;
    }
}

services.service('affiliateSvc', AffiliateSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AffiliateSvc.ts